import { Tools } from "../../utilities/Tools";
import { ModalDialog } from "../ModalDialog";

class DragAndDrop {
  constructor(select, settings = {}) {
    this.select = select;
    this.settings = Object.assign(
      {
        dragAndDropHeaderActive: "Aktywne kolumny",
        dragAndDropHeaderAvailable: "Dostępne kolumny",
        dragAndDropModal: true,
      },
      Tools.parseStringValuesInObjectLiteral(
        (({ dataset }) => {
          const datasetObject = Object.assign({}, dataset);

          delete datasetObject.toggle;
          return datasetObject;
        })(select)
      ),
      Tools.parseStringValuesInObjectLiteral(settings)
    );
    this.modal = undefined;
    this._renderLocationElement = null;
    this._dataAvailable = [];
    this._dataActive = [];
    this.startAvailableBind = this.startAvailable.bind(this);
    this.endAvailableBind = this.endAvailable.bind(this);
    this.overAvailableBind = this.overAvailable.bind(this);
    this.enterAvailableBind = this.enterAvailable.bind(this);
    this.leaveAvailableBind = this.leaveAvailable.bind(this);
    this.dropAvailableBind = this.dropAvailable.bind(this);
    this.startActiveBind = this.startActive.bind(this);
    this.endActiveBind = this.endActive.bind(this);
    this.overActiveBind = this.overActive.bind(this);
    this.enterActiveBind = this.enterActive.bind(this);
    this.leaveActiveBind = this.leaveActive.bind(this);
    this.dropActiveBind = this.dropActive.bind(this);

    // Inicjalizacja
    this.init();
  }

  get renderLocationElement() {
    return this._renderLocationElement;
  }

  set renderLocationElement(value) {
    this._renderLocationElement = value;
  }

  get dataAvailable() {
    return this._dataAvailable;
  }

  set dataAvailable(value) {
    this._dataAvailable = value;

    //
    this.renderAvailableCol();
  }

  get dataActive() {
    return this._dataActive;
  }

  set dataActive(value) {
    this._dataActive = value;

    //
    this.renderActiveCol();
  }

  events() {
    const _this = this;

    this.renderLocationElement.querySelector(".columns-drag-and-drop-modal__move-right").addEventListener("click", (event) => {
      _this.moveRightOptions();
    });

    this.renderLocationElement.querySelector(".columns-drag-and-drop-modal__move-left").addEventListener("click", (event) => {
      _this.moveLeftOptions();
    });
  }

  eventsAvailableCol() {
    const ul = this.renderLocationElement.querySelector(".columns-drag-and-drop-modal__available");

    ul.addEventListener("dragenter", function (event) {
      if (!ul.contains(event.relatedTarget)) {
        ul.classList.add("active");
      }
    });

    ul.addEventListener("dragleave", function (event) {
      if (!ul.contains(event.relatedTarget)) {
        ul.classList.remove("active");
      }
    });

    [...ul.querySelectorAll("li > span")].forEach((item, index) => {
      item.addEventListener("dragstart", this.startAvailableBind);
      item.addEventListener("dragend", this.endAvailableBind);
    });

    [...ul.querySelectorAll("li")].forEach((item, index) => {
      item.addEventListener("dragover", this.overAvailableBind);
      item.addEventListener("dragenter", this.enterAvailableBind);
      item.addEventListener("dragleave", this.leaveAvailableBind);
      item.addEventListener("drop", this.dropAvailableBind);
    });
  }

  eventsActiveCol() {
    const ul = this.renderLocationElement.querySelector(".columns-drag-and-drop-modal__active");

    ul.addEventListener("dragenter", function (event) {
      if (!ul.contains(event.relatedTarget)) {
        ul.classList.add("active");
      }
    });

    ul.addEventListener("dragleave", function (event) {
      if (!ul.contains(event.relatedTarget)) {
        ul.classList.remove("active");
      }
    });

    [...ul.querySelectorAll("li > span")].forEach((item, index) => {
      item.addEventListener("dragstart", this.startActiveBind);
      item.addEventListener("dragend", this.endActiveBind);
    });

    [...ul.querySelectorAll("li")].forEach((item, index) => {
      item.addEventListener("dragover", this.overActiveBind);
      item.addEventListener("dragenter", this.enterActiveBind);
      item.addEventListener("dragleave", this.leaveActiveBind);
      item.addEventListener("drop", this.dropActiveBind);
    });

    [...ul.querySelectorAll(".btn-close")].forEach((item, index) => {
      item.addEventListener("click", (event) => {
        this.removeOption(event.target);
      });
    });
  }

  // dragstart
  startAvailable(event) {
    const dragStartElementId = event.target.id;

    event.dataTransfer.setData("text/plain", dragStartElementId);
    event.dataTransfer.dropEffect = "move";
  }

  startActive(event) {
    const dragStartElementId = event.target.id;

    event.dataTransfer.setData("text/plain", dragStartElementId);
    event.dataTransfer.dropEffect = "move";
  }

  // dragend
  endAvailable(event) {}

  endActive(event) {}

  // dragover
  overAvailable(event) {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  }

  overActive(event) {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  }

  // dragenter
  enterAvailable(event) {
    event.preventDefault();
  }

  enterActive(event) {
    event.preventDefault();
    let localName = event.target.localName;
    const target = event.target;
    const dragStartElement = document.getElementById(event.dataTransfer.getData("text/plain"));

    // Jeżeli przeciągany element jest na samym sobą to przerywamy działąnie funkcji.
    if (dragStartElement.id === target.id) {
      return false;
    }

    switch (localName) {
      case "li":
        break;

      case "span":
        target.classList.add("active");
        target.parentElement.classList.add("active");
        break;
    }
  }

  // dragleave
  leaveAvailable(event) {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  }

  leaveActive(event) {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
    let localName = event.target.localName;
    const target = event.target;
    const dragStartElement = document.getElementById(event.dataTransfer.getData("text/plain"));

    // Jeżeli przeciągany element jest na samym sobą to przerywamy działąnie funkcji.
    if (dragStartElement.id === target.id) {
      return false;
    }

    switch (localName) {
      case "li":
        break;

      case "span":
        target.classList.remove("active");
        target.parentElement.classList.remove("active");
        break;
    }
  }

  // drop
  dropAvailable(event) {
    event.preventDefault();
    const dragStartElement = document.getElementById(event.dataTransfer.getData("text/plain"));
    const dragStartElementRelatedIndex = parseInt(dragStartElement.dataset.relatedIndex);
    const dragStartElementParentIndex = parseInt(dragStartElement.parentElement.dataset.index);
    const dragStartElementSourceColumnId = dragStartElement.closest("ul").dataset.id;
    const newDataActive = [...this.dataActive];
    const newDataAvailable = [...this.dataAvailable];

    switch (dragStartElementSourceColumnId) {
      // Przciąganie opcji w obrębie #columns-drag-and-drop-modal-available.
      case "columns-drag-and-drop-modal-available":
        break;

      // Przciąganie opcji z #columns-drag-and-drop-modal-active do #columns-drag-and-drop-modal-available.
      case "columns-drag-and-drop-modal-active":
        //
        newDataAvailable[dragStartElementRelatedIndex].selected = false;

        //
        newDataActive.splice(dragStartElementParentIndex, 1);
        break;

      default:
        break;
    }

    this.dataAvailable = newDataAvailable;
    this.dataActive = newDataActive;
  }

  dropActive(event) {
    event.preventDefault();
    const target = event.target;
    const targetIndex = parseInt(target.closest("li").dataset.index);
    const dragStartElement = document.getElementById(event.dataTransfer.getData("text/plain"));
    const dragStartElementRelatedIndex = parseInt(dragStartElement.dataset.relatedIndex);
    const dragStartParentElementIndex = parseInt(dragStartElement.closest("li").dataset.index);
    const dragStartElementSourceColumnId = dragStartElement.closest("ul").dataset.id;
    const newDataActive = [...this.dataActive];
    const newDataAvailable = [...this.dataAvailable];

    switch (dragStartElementSourceColumnId) {
      // Przciąganie opcji z #columns-drag-and-drop-modal-available do #columns-drag-and-drop-modal-active.
      case "columns-drag-and-drop-modal-available":
        //
        newDataAvailable[dragStartElementRelatedIndex].selected = true;

        if (this.dataActive.length === 0) {
          newDataActive.push(newDataAvailable[dragStartElementRelatedIndex]);
        } else {
          newDataActive.splice(targetIndex, 0, newDataAvailable[dragStartElementRelatedIndex]);
        }

        break;

      // Przciąganie opcji w obrębie #columns-drag-and-drop-modal-active.
      case "columns-drag-and-drop-modal-active":
        if (dragStartParentElementIndex < targetIndex) {
          // Przeciąganie góra -> dół.
          newDataActive.splice(targetIndex + 1, 0, newDataActive[dragStartParentElementIndex]);
          newDataActive.splice(dragStartParentElementIndex, 1);
        }

        if (dragStartParentElementIndex > targetIndex) {
          // Przeciąganie dół -> góra.
          newDataActive.splice(targetIndex, 0, newDataActive[dragStartParentElementIndex]);
          newDataActive.splice(dragStartParentElementIndex + 1, 1);
        }

        break;

      default:
        break;
    }

    this.dataAvailable = newDataAvailable;
    this.dataActive = newDataActive;
  }

  renderAvailableCol() {
    const _this = this;

    this.renderLocationElement.querySelector(".columns-drag-and-drop-modal-available__col").innerHTML = `
                    <h2 class="h6 fw-bold bg-light p-3 mb-5 mb-xl-2 text-center">${_this.settings.dragAndDropHeaderAvailable}</h2>
                    <ul data-id="columns-drag-and-drop-modal-available"
                        class="list-group columns-drag-and-drop-modal__available ${
                          !this.checkIfAllAvailableAreSelected() ? "columns-drag-and-drop-modal__active--exists" : ""
                        }" data-text="Przeciągnij i upuść tutaj..."> 
                        ${(function (options) {
                          let html = ``;
                          let optionsLength = options.length;
                          const filteredOptions = options.filter((option) => {
                            return !option.selected;
                          });

                          for (let index = 0; index < optionsLength; index++) {
                            const option = filteredOptions[index];

                            html += `<li data-index="${index}">${(function () {
                              if (Boolean(option)) {
                                return `<span id="${_this.select.id}-${option.value}" draggable="true" data-related-index="${option.relatedIndex}" data-value="${option.value}" data-text="${option.text}"></span>`;
                              } else {
                                return ``;
                              }
                            })()}</li>`;
                          }

                          return html;
                        })(_this.dataAvailable)}
                    </ul>
                    `;

    //
    this.eventsAvailableCol();
  }

  renderActiveCol() {
    const _this = this;

    this.renderLocationElement.querySelector(".columns-drag-and-drop-modal-active__col").innerHTML = `
                    <h2 class="h6 fw-bold bg-light p-3 mb-5 mb-xl-2 text-center">${_this.settings.dragAndDropHeaderActive}</h2>
                    <ul data-id="columns-drag-and-drop-modal-active"
                        class="list-group columns-drag-and-drop-modal__active ${
                          this.dataActive.length > 0 ? "columns-drag-and-drop-modal__active--exists" : ""
                        }" data-text="Przeciągnij i upuść tutaj...">
                        ${(function (options) {
                          let html = ``;
                          let optionsLength = _this.dataAvailable.length;
                          const filteredOptions = options.filter((option) => {
                            return option.selected;
                          });

                          for (let index = 0; index < optionsLength; index++) {
                            const option = filteredOptions[index];

                            html += `<li data-index="${index}">${(function () {
                              if (Boolean(option)) {
                                return `<span id="${_this.select.id}-${option.value}" draggable="true" data-related-index="${option.relatedIndex} data-value="${option.value}" data-text="${option.text}"><button type="button" class="btn-close" aria-label="Usuń"></button></span>`;
                              } else {
                                return ``;
                              }
                            })()}</li>`;
                          }

                          return html;
                        })(_this.dataActive)}
                    </ul>
                    `;

    //
    this.eventsActiveCol();
  }

  renderFormSelectCombobox() {
    let nextElementSibling = this.select.nextElementSibling;

    if (Boolean(nextElementSibling)) {
      nextElementSibling.remove();
    }

    this.select.insertAdjacentHTML(
      "afterend",
      `
            <div class="combobox">
                <div class="combobox__header">Wybrano: ${this.select.options.length === this.select.selectedOptions.length ? "wszystkie" : this.select.selectedOptions.length}</div>
            </div>
            `
    );

    this.select.parentElement.setAttribute(
      "title",
      (function ({ selectedOptions }) {
        return [...selectedOptions]
          .map((option, index) => {
            return option.value;
          })
          .join(", ");
      })(this.select)
    );
  }

  render() {
    this.renderLocationElement.insertAdjacentHTML(
      "beforeend",
      `
            <div class="columns-drag-and-drop-modal ${"ontouchstart" in document ? "columns-drag-and-drop-modal--touch" : ""}">
                <div class="columns-drag-and-drop-modal__move">
                    <button type="button"
                            class="btn btn-sm btn-outline-primary columns-drag-and-drop-modal__move-right"
                            title="Przenieś wszystkie pozycje na prawą stronę.">
                        <i class="fas fa-angle-double-right"></i>
                    </button>
                    <button type="button"
                            class="btn btn-sm btn-outline-primary columns-drag-and-drop-modal__move-left"
                            title="Przenieś wszystkie pozycje na lewą stronę.">
                        <i class="fas fa-angle-double-left"></i>
                    </button>
                </div>
                <div class="row">
                    <div class="col-6 pe-xl-5 columns-drag-and-drop-modal-available__col"></div>
                    <div class="col-6 ps-xl-5 columns-drag-and-drop-modal-active__col"></div>
                </div>
            </div>
            `
    );

    // Data
    const dataAvailable = [];
    const dataActive = [];

    [...this.select.options].forEach((option, index) => {
      dataAvailable.push({
        text: option.text,
        value: option.value,
        selected: option.selected,
        relatedIndex: index,
        element: option,
      });

      if (option.selected) {
        dataActive.push({
          text: option.text,
          value: option.value,
          selected: option.selected,
          relatedIndex: index,
          element: option,
        });
      }
    });

    this.dataAvailable = dataAvailable;
    this.dataActive = dataActive;

    // Ustawienie zdarzeń.
    this.events();
  }

  showDefaultSelect() {
    this.select.classList.remove("d-none");
  }

  hideDefaultSelect() {
    this.select.classList.add("d-none");
  }

  moveRightOptions() {
    const newDataAvailable = [...this.dataAvailable];
    const newDataActive = [...this.dataActive];

    newDataAvailable.forEach((option, index) => {
      if (!option.selected) {
        option.selected = true;
        newDataActive.push(option);
      }
    });

    this.dataAvailable = newDataAvailable;
    this.dataActive = newDataActive;
  }

  moveLeftOptions() {
    const newDataAvailable = [...this.dataAvailable];
    const newDataActive = [];

    newDataAvailable.forEach((option, index) => {
      if (option.selected) {
        option.selected = false;
      }
    });

    this.dataAvailable = newDataAvailable;
    this.dataActive = newDataActive;
  }

  removeOption(target) {
    const newDataAvailable = [...this.dataAvailable];
    const newDataActive = [...this.dataActive];
    const deletedElement = target.parentElement;
    const deletedElementRelatedIndex = parseInt(deletedElement.dataset.relatedIndex);
    const deletedElementParentIndex = parseInt(deletedElement.parentElement.dataset.index);

    //
    newDataAvailable[deletedElementRelatedIndex].selected = false;

    //
    newDataActive.splice(deletedElementParentIndex, 1);

    this.dataAvailable = newDataAvailable;
    this.dataActive = newDataActive;
  }

  updateSelectOptions() {
    const newDataAvailable = [];

    this._dataAvailable.forEach((option, index) => {
      if (!option.selected) {
        newDataAvailable.push(option);
      }
    });

    const newOptions = this.dataActive.concat(newDataAvailable);

    this.select.innerHTML = (function () {
      return newOptions
        .map((option, index) => {
          return `<option value="${option.value}" ${option.selected ? "selected" : ""}>${option.text}</option>`;
        })
        .join("");
    })();

    this.select.form.submit();
  }

  checkIfAllAvailableAreSelected() {
    return this.dataAvailable.every((option, index) => {
      return option.selected;
    });
  }

  init() {
    // Jeżeli select multiple jest disabled nie renderujemy combobox'a i zostawiamy nieaktywny select.
    if (this.select.disabled) {
      this.select.size = 1;
      this.select.parentElement.classList.remove("form-select");
      return false;
    }

    // Ukrycie domyślnego, przeglądarkowego selecta z multiple, jeżeli ma być zastosowany combobox.
    this.hideDefaultSelect();

    if (this.settings.dragAndDropModal) {
      // ModalDialog
      this.modal = new ModalDialog(this.select.parentElement, {
        modalTitle: "Kolumny",
        modalSize: "modal-lg",
        modalConfirmButton: {
          visible: true,
          text: "Zastosuj",
        },
      });

      //
      this.modal.showFunction = () => {
        // Miejsce renderowania listy drag and drop.
        this.renderLocationElement = document.querySelector("#modal .modal-body");

        this.render();
      };

      //
      this.modal.confirmFunction = () => {
        this.updateSelectOptions();
      };

      //
      this.renderFormSelectCombobox();
    } else {
      let selectParentElement = this.select.parentElement;

      // Usunięcie klasy
      selectParentElement.classList.remove("form-select");

      // Miejsce renderowania listy drag and drop.
      this.renderLocationElement = selectParentElement;

      this.render();
    }
  }
}

export { DragAndDrop };
